import Vue from 'vue'
import VueFacebookPixel from 'vue-facebook-pixel'
 
Vue.use(VueFacebookPixel)

export default (_) => { }